export const LMSBASEURL = process.env.REACT_APP_API_LMS;
const AWS = process.env.REACT_APP_AWS_HOST;
export const API = process.env.REACT_APP_API_URL;


export const apiUrl = {
    auth:{
        login:`${API}/api/login`,
        forgotPass:`${API}/api/forgot-password`
    },
    student: {
        dashboard: ({ studentId, categoryId }) =>
        `${LMSBASEURL}/api/student/dashboard?student_id=${parseInt(studentId)}&category_id=${categoryId}`,
    },
    quizApplicationSubmission:`${LMSBASEURL}/api/quiz-application-submission`,
    likeDisLike:`${LMSBASEURL}/api/like-dislike`,
    markChapter:`${LMSBASEURL}/api/mark-chapter`,
    comment:`${LMSBASEURL}/api/comment`,
    updateComment:`${LMSBASEURL}/api/update_comment`,

    
    commentList:({chapterId})=>`${LMSBASEURL}/api/comment-list?chapter_id=${chapterId}`,
    deleteComment:({commentId})=>`${LMSBASEURL}/api/comment/${commentId}`,
    enrolledprogram:({studentId,categoryId})=>`${LMSBASEURL}/api/enrolledprogram?student_id=${studentId}&role=Student&category_id=${categoryId}`,
    programsindetails:({studentId,categoryId,programId})=> `${LMSBASEURL}/api/programsindetails?student_id=${studentId}&role=Student&category_id=${categoryId}&program_id=${programId}`,
    program:({programCategory,role})=>`${LMSBASEURL}/api/programs?category=${programCategory}&role=${role}`,
    accomplishments:({studentId})=>`${LMSBASEURL}/api/accomplishments?studentId=${studentId}`,



    creditAllocations:({InstituteId, role})=>`${LMSBASEURL}/api/credit-allocations?user_id=${InstituteId}&role_name=${role}`,
    getCreditTransaction:({userId})=>`${LMSBASEURL}/api/get-credit-transaction?user_id=${userId}`,


    // AI URL
    subscriptionDeductCredit:'/api/subscription/deduct_plan',
    subscriptionGetCredit:'/api/subscription/getPlan',
    
    CommunicationPrepStart:'/api/communication/communication-start',
    CommunicationEvaluation:'/api/communication/communication-evaluate',
    CommunicationHistory:'/api/communication/communication-history',
    CommunicationId:'/api/communication/communication-id',
    CommunicationList:'/api/communication/communication-list',
    Communication:'/api/communication',
    CommunicationFirstStart: '/api/communication/communication-first-start',

    InterviewPrepStart:'/api/interview-prep/interview-start',
    InterviewEvaluation:'/api/interview-prep/interview-evaluate',
    InterviewHistory:'/api/interview-prep/interview-history',
    InterviewId:'/api/interview-prep/interview-id',
    InterviewList:'/api/interview-prep/interview-list',
    Interview:'/api/interview-prep',
    InterviewFirstStart: '/api/interview-prep/interview-first-start',

    debatePrepStart:'/api/debate/debate-start',
    debateEvaluation:'/api/debate/debate-evaluate',
    debateHistory:'/api/debate/debate-history',
    debateId:'/api/debate/debate-id',
    debateList:'/api/debate/debate-list',
    debate:'/api/debate',

};

export const toBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
});